module.exports = __webpack_public_path__ + "img/02.b7af868b.png";